import { gql } from '@apollo/client';
import { PAS_FIND_FRAGMENT } from './getSitePasFindsQuery';

export const UPDATE_PAS_FIND_MUTATION = gql`
  mutation UpdatePasFindMutation($id: String!, $find: FindInput!) {
    updateFind(id: $id, find: $find) {
      ... on UpdateFindSuccess {
        find {
          ...PasFindFields
        }
      }
      ... on ValidationError {
        errors {
          error
          path
        }
      }
    }
  }
  ${PAS_FIND_FRAGMENT}
`;
